import {AfterViewInit, Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Product} from "../../product-details/interface/product";
import {SettingsDataService} from "../../services/settings-data.service";
import {CurrencyResolverService} from "../../currency-resolver.service";
import {ApCurrency} from "../../pipe/enum/ap-currency";
import {PipeModule} from "../../pipe/pipe.module";

@Component({
  selector: 'fb-product-swatch-button',
  standalone: true,
	imports: [CommonModule, PipeModule],
  templateUrl: './product-swatch-button.component.html',
  styleUrls: ['./product-swatch-button.component.scss']
})
export class ProductSwatchButtonComponent implements AfterViewInit {

	@Input() product: Product = {} as Product;
	public swatchPrice: number = 0;
	public selectedCurrency: ApCurrency = ApCurrency.INR;

	constructor(
		private _setting: SettingsDataService,
		public _currencyResolver: CurrencyResolverService,
	) {
	}

	ngAfterViewInit() {
		this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		this._currencyResolver.selectCurrencyChange.subscribe(()=> {
			this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
			if(this._setting.swatchDiscount) {
				this.swatchPrice = (this._setting.swatchDiscount/100) * this.product.price;
			}
		});

		if(this._setting.swatchDiscount) {
			this.swatchPrice = (this._setting.swatchDiscount/100) * this.product.price;
		}
	}
}
